import { TmaisUserData } from "../types/tmaisUsers.type";
import TmaisUserGeneralData from "../tabs/users/components/showUser/GeneralData";
import ConsumptionDataTab from "../tabs/users/components/showUser/ConsumptionData";
import RedemptionHistoryTab from "../tabs/users/components/showUser/RedemptionHistory";
import { TabsProps } from "@/common/components/Tabs";

interface DefaultTabsProps {
  tmaisUser: TmaisUserData
}

export const defaultTabs = ({tmaisUser}: DefaultTabsProps) => {
  const tabs: TabsProps['tabsList'] = [
    {
      label: 'Dados Gerais',
      value: '',
      body: <TmaisUserGeneralData tmaisUser={tmaisUser} />
    },
    {
      label: 'Dados de consumo',
      value: 'consumptions',
      body: <ConsumptionDataTab userId={tmaisUser?.id} />,
      operationKlassToCheckPermission: 'Establishment::Tmais::Consumptions::Filter',
    },
    {
      label: 'Histórico',
      value: 'history',
      body: <RedemptionHistoryTab userId={tmaisUser?.id} />,
      operationKlassToCheckPermission: 'Establishment::Tmais::RewardLedgerEntries::Filter',
    },
  ]

  return tabs
}
